export enum InterestGroups {
    Unknown = 'Unknown',
    Generic = 'Generic',
    LookingFor = 'LookingFor',
    RelationshipType = 'RelationshipType',
    RelationshipForm = 'RelationshipForm',
    Activity = 'Activity',
    Kink = 'Kink',
    BookType = 'BookType',
    TurnOn = 'TurnOn',
    Leisure = 'Leisure',
    Creativity = 'Creativity',
    SelfDevelopment = 'SelfDevelopment',
    Entertainment = 'Entertainment',
    Sports = 'Sports',
    Gastronomy = 'Gastronomy',
    Vibe = 'Vibe',
    RelationshipStatus = 'RelationshipStatus',
    Children = 'Children',
    Ethnicity = 'Ethnicity',
    Drink = 'Drink',
    Smoke = 'Smoke',
    Cannabis = 'Cannabis',
    Dealbreaker = 'Dealbreaker',
    Fantasy = 'Fantasy',
}

export const InterestGroupsName: Record<InterestGroups, string> = {
    [InterestGroups.Unknown]: 'Неизвестно',
    [InterestGroups.Generic]: 'Интересы',
    [InterestGroups.LookingFor]: 'Ищет',
    [InterestGroups.RelationshipType]: 'Тип отношений',
    [InterestGroups.RelationshipForm]: 'Форма отношений',
    [InterestGroups.Activity]: 'Активность',
    [InterestGroups.Kink]: 'Кинк',
    [InterestGroups.BookType]: 'Тип книг',
    [InterestGroups.TurnOn]: 'Возбуждает',
    [InterestGroups.Leisure]: 'Досуг',
    [InterestGroups.Creativity]: 'Творчество',
    [InterestGroups.SelfDevelopment]: 'Саморазвитие',
    [InterestGroups.Entertainment]: 'Развлечения',
    [InterestGroups.Sports]: 'Спорт',
    [InterestGroups.Gastronomy]: 'Гастрономия',
    [InterestGroups.Vibe]: 'Вайб',
    [InterestGroups.RelationshipStatus]: 'Статус отношений',
    [InterestGroups.Children]: 'Дети',
    [InterestGroups.Ethnicity]: 'Этнос',
    [InterestGroups.Drink]: 'Алкоголь',
    [InterestGroups.Smoke]: 'Курение',
    [InterestGroups.Cannabis]: 'Каннабис',
    [InterestGroups.Dealbreaker]: 'Стоп-факторы',
    [InterestGroups.Fantasy]: 'Фантазии',
};